/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import * as React from 'react';
import { useGlobalState } from 'src/core/hooks/useGlobalState';
import { initializeLoggerFromRoot } from 'src/core/services/telemetry/telemetryLogger';

/**
 * Initializes loggers from the root store. This is
 * added in a separate hook for future compatibility if
 * we ever need state specific logic when initializing
 * loggers or telemetry.
 */
export const useInitializeLogger = () => {
    const { rootStore, uiStore } = useGlobalState();
    React.useEffect(() => initializeLoggerFromRoot(rootStore, uiStore), []);
};
